function Link({href,isBlank=true,children}) {

    return (
        <a href={href} {...(isBlank?{target:'_blank'}:{})}>
            {children}
        </a>
    );
}
export default Link;